import React, { Component } from 'react';
import {Link} from 'react-router-dom';




class MarkSheetItem extends Component {

   constructor(props) {
    super(props);

    
    this.updateAttendance= this.updateAttendance.bind(this);
    this.updateExam= this.updateExam.bind(this);
    this.updateCat = this.updateCat.bind(this);
    this.getGrade = this.getGrade.bind(this);

     this.state={
         AdmnNo: props.marksheet_details.AdmnNo,
         Att:props.marksheet_details.Att,
         Exam:props.marksheet_details.EXAM,
         Cat:props.marksheet_details.CAT
         
        
     }
  }

  

 


  updateAttendance(event) {
    event.preventDefault();

    let att = event.target.value;
    this.setState({Att: att});

    this.props.updateAttendance(this.state.AdmnNo, att);
  }

  updateExam(event) {
    event.preventDefault();

    let exam = event.target.value;
    console.log("update exam");
    this.setState({Exam: exam});

    this.props.updateEXAM(this.state.AdmnNo, exam);
  }

  updateCat(event) {
    event.preventDefault();

    let cat = event.target.value;
    
    this.setState({Cat: cat});

    this.props.updateCAT(this.state.AdmnNo, cat);
  }

  getGrade(marks)
    {
            if(this.props.grading != undefined && this.props.grading != null)
            {
                let grade = "NA";

                for(let i = 0;  i < this.props.grading.length; i++)
                {
                let lowerLimit = this.props.grading[i].Range.split("-")[0];
                let upperLimit = this.props.grading[i].Range.split("-")[1];

                if(marks>=lowerLimit && marks<=upperLimit)
                {
                    grade = this.props.grading[i].Names;
                    break;
                }
                }

                return grade;
            }
            else {
                return "NA";
            }

    }



  render() {
    const _this=this;

    return (
        <tr>
            <th className = "table-ms-content">{_this.props.marksheet_details.AdmnNo}</th>
            <th className = "table-ms-content">{_this.props.marksheet_details.names}</th>
            <th className = "table-ms-content-numbers"><input type="text" width="10px" onChange={_this.updateAttendance.bind(_this)}  className="form-control" value={_this.props.marksheet_details.Att == null ? "": _this.props.marksheet_details.Att}/></th>
            <th className = "table-ms-content-numbers" ><input type="number" width="5px" onChange={_this.updateCat.bind(_this)}  className="form-control" value={_this.state.Cat== null ? "": _this.state.Cat}/></th>
            <th className = "table-ms-content-numbers"><input type="number" width="10px" onChange={_this.updateExam.bind(_this)}  className="form-control" value={_this.state.Exam == null ? "": _this.state.Exam}/></th>
            <th className = "table-ms-content-numbers">{(_this.state.Cat != null && _this.state.Exam != null) ? parseInt(_this.state.Exam) + parseInt(_this.state.Cat): "-" }</th>
            <th className = "table-ms-content-numbers">{(_this.state.Cat != null && _this.state.Exam != null) ? _this.getGrade(parseInt(_this.state.Exam) + parseInt(_this.state.Cat)): "-" }</th>
            
            
       </tr>


    );
  }




}

export default MarkSheetItem;